module.exports = __webpack_public_path__ + "static/media/work-with-us-4.fdc396e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/07_Foto-Work-with-us/work-with-us-4.jpg
// module id = 743
// module chunks = 0